import { createStore } from 'vuex';
import getters from './getters';

// 引入modules中的内容
import app from './modules/app';
import dataInit from './modules/dataInit';
import multipleNav from './modules/multipleNav';
// import permission from './modules/permission';
// import user from './modules/user';
import demand from './modules/demand';
import selfAnalysis from './modules/selfAnalysis';
import home from './modules/home';

export default createStore({
  getters,
  modules: {
    app,
    dataInit,
    multipleNav,
    // user,
    // permission,
    demand,
    selfAnalysis,
    home,
  },
});
